export * from "./documentTemplate";
